import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
import MyUploadAdapter from "./uploadAdapter"

window.ClassicEditor = ClassicEditor;
window.MyUploadAdapter = MyUploadAdapter;

$(function () {
  /**
   * CKEditor Classic
   */
  if (document.querySelector("#content")) {
    ClassicEditor.create(document.querySelector("#content"))
      .then(editor => {
        editor.plugins.get("FileRepository").createUploadAdapter = loader => {
          return new MyUploadAdapter(loader)
        }
        // console.log(editor)
      })
      .catch(error => {
        console.error(error)
      })
  }
})
